import styled from 'styled-components'

export const CardHighlightStyle = styled.div`
  border-color: ${(props) => props.theme.card?.borderColor || '#FFC000'};
  background-color: yellow;
  color: ${(props) =>
    props.theme.highlight?.color || props.theme.color || '#000000'};
  border-top-style: solid;
  border-left-style: solid;
  border-right-style: solid;
  border: ${(props) => props.theme.card?.border || 'solid 2px'};
  border-top-left-radius: ${(props) =>
    props.theme.card?.borderRadius || '1.5em'};
  border-top-right-radius: ${(props) =>
    props.theme.card?.borderRadius || '1.5em'};
  position: absolute;
  z-index: -1;
  text-align: center;
  width: 100%;
  /* width: ${(props) => props.theme.card?.width || '180px'}; */
  min-height: ${(props) => props.theme.highlight?.height || '2.7em'};
  padding: 0.5em 0 0.25em 0;
  display: flex;
  flex-direction: column;
  top: -2.5em;
`
